//libs
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { axiosInstance } from "./config";
//context
import { AuthContext } from "context/useAuth";

export const useLogin = () => {
  const [user, setUser] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const { setToken } = useContext(AuthContext);

  const navigate = useNavigate();

  const login = (body) => {
    try {
      setIsLoading(true);
      axiosInstance.post("login", body).then((res) => {
        if (res) {
          localStorage.setItem("token", res.access_token);
          setToken(res.access_token);
          setUser(res.data);
          setIsLoading(false);
          toast.success("Logged In Successfully");
          navigate("/");
          return;
        }
        // toast.error("Email or password is incorrect");
      });
    } catch (err) {
      console.log("login error: => ", err);
    } finally {
      setIsLoading(false);
    }
  };
  return { user, isLoading, login };
};
